module.exports = __webpack_public_path__ + "img/3.19544f57.png";